export var CurrencyType;
(function (CurrencyType) {
    CurrencyType["EURO"] = "euro";
    CurrencyType["DOLLAR"] = "dollar";
})(CurrencyType || (CurrencyType = {}));
